export const UPDATE_DATA = 'app/EditSessionPage/Textbox/UPDATE';
export const UPDATE_VARIABLE = 'app/EditSessionPage/Textbox/UPDATE_VARIABLE';
